import { makeAuthenticatedRequest } from './api';

const aiModelApi = {
  modelConfig: {
    list: async () => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-model-config', { operation: 'list' });
    },
    add: async (modelData) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-model-config', { operation: 'add', model_data: modelData });
    },
    edit: async (modelData) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-model-config', { operation: 'edit', model_data: modelData });
    }
  },
  levelManager: {
    getModelsByAgent: async (agentId) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-level-manager', { command: 'get_models_by_agent', agent_id: agentId });
    },
    getAllModels: async () => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-level-manager', { command: 'get_all_models' });
    },
    updateLevel: async (data) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-level-manager', { command: 'update_level', ...data });
    },
    deleteLevel: async (agentId, level) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-level-manager', { command: 'delete_level', agent_id: agentId, llm_level: level });
    }
  },
  dashboard: {
    getAgentTotals: async (filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'agent_totals', ...filters });
    },
    getMiniAgentBreakdown: async (agentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'mini_agent_breakdown', agent_id: agentId, ...filters });
    },
    getMicroAgentBreakdown: async (agentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'micro_agent_breakdown', agent_id: agentId, ...filters });
    },
    getModelBreakdown: async (agentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'model_breakdown', agent_id: agentId, ...filters });
    },
    getLevelBreakdown: async (agentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'level_breakdown', agent_id: agentId, ...filters });
    },
    getLlmCallLogs: async (agentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'llm_call_logs', agent_id: agentId, ...filters });
    },
    getPendingCalls: async (agentId) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'pending_calls', agent_id: agentId });
    },
    getMicroAgentDetails: async (microAgentId, filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/llm-statistics', { command: 'micro_agent_details', micro_agent_id: microAgentId, ...filters });
    }
  },
  modelTesting: {
    submitJob: async (data) => {
      return await makeAuthenticatedRequest('POST', '/llm/test', { operation: 'submit', ...data });
    },
    getJobStatus: async (jobId) => {
      return await makeAuthenticatedRequest('POST', '/llm/test', { operation: 'status', job_id: jobId });
    },
    listJobs: async (filters) => {
      return await makeAuthenticatedRequest('POST', '/llm/test', { operation: 'list', ...filters });
    },
    getAvailableModels: async (agentId = null) => {
      const payload = { operation: 'models' };
      
      // FIX: Robust handling for agentId parameter
      // If agentId is passed as an object { agent_id: 123 }, extract the ID
      if (agentId !== null && agentId !== undefined) {
        if (typeof agentId === 'object' && agentId.agent_id) {
          payload.agent_id = agentId.agent_id;
        } else if (typeof agentId !== 'object') {
          // Normal case: scalar value
          payload.agent_id = agentId;
        }
      }
      
      return await makeAuthenticatedRequest('POST', '/llm/test', payload);
    }
  }
};

export default aiModelApi;